interface SourceBannerProps {
  title: string;
  text: string;
  icon?: string;
}

const SourceBanner = ({ title, text, icon = "INFO" }: SourceBannerProps) => {
  return (
    <div className="craSourceBanner">
      <div className="craSourceBanner__icon">{icon}</div>
      <div className="craSourceBanner__text">
        <strong>{title}</strong>
        <p>{text}</p>
      </div>
    </div>
  );
};

export default SourceBanner;
